import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'values'
})
export class ValuesPipe implements PipeTransform {

  transform<T>(value: { [s: string]: T; } | ArrayLike<T>): T[] {
    return Object.values(value);
  }
}
